import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { CustomeStyle } from "../Css/CustomeStyle";
import Footer from "../Fotter";
import AllProduct from "./AllProduct";
import Header from "./header";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FiArrowRight } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { FiShoppingCart } from "react-icons/fi";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../redux/slices/AllProductSlice";
import { AddToCart } from "../redux/slices/AddTocartSlice";
import { toast } from "react-toastify";
import { GetRecentView } from "../redux/slices/GetRecentViewSlice";
import { AddWishlist } from "../redux/slices/AddWishlistSlice";
import { GetOfferName } from "../redux/slices/GetOfferNameSlice";
import { GetOffer } from "../redux/slices/GetOfferSlice";
import { GetBanner } from "../redux/slices/GetBannerSlice";
import { Sparkles } from "lucide-react";
import axios from "axios";
import endPoint from "../redux/EndPoint/endpoint";

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [likedProducts, setLikedProducts] = useState(new Set());
  const { AllData } = useSelector((state) => state.product);
  // const { GetRecentData } = useSelector((state) => state.viewData);
  // const { OfferData } = useSelector((state) => state?.offerData);
  // const { GetBanners } = useSelector((state) => state?.getBannerData);
  // const [images, setImages] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [categoryDataMap, setCategoryDataMap] = useState({});
  const [hasFetched, setHasFetched] = useState(false);
  const { AllCategory } = useSelector((state) => state?.category);
  // const { ProductDetailsData } = useSelector((state) => state?.productById);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // useEffect(() => {
  //   if (GetBanners?.data) {
  //     setImages(GetBanners.data[0]?.images);
  //   }
  // }, [GetBanners]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       dispatch(GetRecentView());
  //       dispatch(GetOfferName());
  //       dispatch(GetBanner());
  //       await dispatch(fetchProducts()).unwrap();
  //     } catch (error) {
  //       console.log("Error", Error)
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, [dispatch]);

  // useEffect(() => {
  //   dispatch(GetOffer());
  // }, [dispatch]);

  const toggleLike = (productId) => {
    dispatch(AddWishlist(productId));
    setLikedProducts((prevLikedProducts) => {
      const updatedLikes = new Set(prevLikedProducts);
      if (updatedLikes.has(productId)) {
        updatedLikes.delete(productId);
      } else {
        updatedLikes.add(productId);
      }
      return updatedLikes;
    });
  };

  const handleAddToCart = (item) => {
    const cartData = {
      productId: item?._id,
      quantity: 1,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
      } else {
        console.log("Responce Error");
      }
    });
  };

  const _handleOfferData = () => {
    navigate("/TopSellDetails");
  };

  const generateSlug = (text) => {
    if (!text) return "";

    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\- ]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const filteredProducts = AllData?.products?.filter(
    (product) => product?.istopsellproduct === true
  );

  // const productsToShow =
  //   // SeachProductData?.products?.length > 0
  //   //   ? SeachProductData.products.slice(30) :
  //   AllData?.products?.length > 0
  //     ? AllData.products.slice(0, 30).reverse()
  //     : [];

  function getRandomCategories(allCategories, count = 10) {
    const shuffled = [...allCategories].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  }



  // useEffect(() => {
  //   const loadInitialData = async () => {
  //     if (!AllCategory?.length || hasFetched) return;
  //     setLoading(true);
  //     const selected = getRandomCategories(AllCategory);
  //     const names = selected.map((cat) => cat.name);
  //     console.log("name", names)
  //     const newCategoryDataMap = {};
  //     for (const name of names) {
  //       try {
  //         const res = await axios.get(`${endPoint.GETCATEGORYDATA}/${encodeURIComponent(name)}`);
  //         if (res?.data?.products?.length > 0) {
  //           newCategoryDataMap[name] = res.data;
  //         }
  //       } catch (error) {
  //         console.log(`Category error: ${name}`, error.message);
  //       }
  //     }
  //     // try {
  //     //   const trendingRes = await axios.get(endPoint.GetTrandingProduct);
  //     //   const topRes = await axios.get(endPoint.GetTopSaleProduct);
  //     //   // setTrendingProducts(trendingRes?.data?.trendingProducts || []);
  //     //   // setTopProducts(topRes?.data || []);
  //     // } catch (error) {
  //     //   console.log("Trending or TopSale error", error.message);
  //     // }

  //     console.log("newCategoryDataMap", newCategoryDataMap)
  //     setCategoryDataMap(newCategoryDataMap);
  //     setLoading(false);
  //     setHasFetched(true);
  //   };

  //   loadInitialData();
  // }, [AllCategory, hasFetched]);

  useEffect(() => {
    const loadInitialData = async () => {
      if (!AllCategory?.length || hasFetched) return;

      try {
        setLoading(true);
        const selected = getRandomCategories(AllCategory);
        const names = selected.map((cat) => cat.name);
        const newCategoryDataMap = {};

        for (const name of names) {
          try {
            const res = await axios.get(`${endPoint.GETCATEGORYDATA}/${encodeURIComponent(name)}`);
            if (res?.data?.products?.length > 0) {
              newCategoryDataMap[name] = res.data;
            }
          } catch (error) {
            console.error(`Category error: ${name}`, error.message);
          }
        }
        setCategoryDataMap(newCategoryDataMap);
        setHasFetched(true);
      } catch (err) {
        console.error("Unexpected error:", err);
      } finally {
        setLoading(false);
      }
    };

    loadInitialData();
  }, [AllCategory, hasFetched]);

  return (
    <div className="">
      <Header />
      <div className="flex flex-col min-h-screen">
        <div className="flex-grow">
          {/* <div className="h-[20%] bg-white flex flex-col lg:flex-row sm:w-[92%] w-[100%] sm:mt-0 mt-[-5%] p-4 justify-evenly self-center mx-auto overflow-hidden items-center">
            <div className="w-full lg:w-[100%]  lg:mt-0 hidden lg:block ">
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={30}
                slidesPerView={1}
                centeredSlides={true}
                loop={true}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                navigation={true}
                className="w-full"
              >
                {images.map((image, index) => (
                  <SwiperSlide key={index}>
                    <div className="w-full h-[250px] sm:h-[300px] md:h-[400px] relative">
                      <img loading="lazy"
                        src={image}
                        alt={`Promotion (${index + 1})`}
                        className="w-full h-[250px] sm:h-[300px] md:h-[400px] object-cover rounded-lg"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div> */}
          {/* ------------------------------------------------------ Offer --------------------------------------------------- */}
          {/* {OfferData?.flags &&
            OfferData?.flags?.slice(0, 2)?.map((flagData) => (
              <div key={flagData.flag} className={CustomeStyle.container}>
                <div className="mb-2">
                  <div className={`${CustomeStyle.row} flex items-center gap-4`}>
                    <div className="flex justify-between items-center w-full sm:mb-2 mb-0">
                      <div className="flex flex-row items-center ">
                        <h3 className={CustomeStyle.headerText}>{flagData.flag}</h3>
                        <Sparkles className="h-5 w-5  mx-auto animate-bounce ms-3" />
                      </div>
                      {flagData?.products?.length >= 8 && (
                        <Link
                          to={`/${flagData.flag.toLowerCase()}`}
                          className="text-red-500 hover:text-red-700 flex items-center space-x-2"
                        >
                          <span className="text-black font-bold">View All</span>
                          <FiArrowRight color="#000" size={18} />
                        </Link>
                      )}
                    </div>
                  </div>

                  <div className="flex overflow-x-auto mt-2 gap-4 no-scrollbar">
                    {flagData?.products?.map((item) => {
                      return (
                        <div
                          key={item._id}
                          className="bg-gray-100 rounded-lg py-2 px-1 w-[140px] sm:w-[180px] md:w-[150px] flex-none text-center flex flex-col items-center justify-center relative cursor-pointer overflow-hidden"
                        >
                          <button
                            className="like-btn absolute top-2 right-2"
                            onClick={() => toggleLike(item._id)}
                          >
                            {likedProducts.has(item._id) ? (
                              <FaHeart size="24px" color="red" />
                            ) : (
                              <FaRegHeart size="24px" color="gray" />
                            )}
                          </button>
                          <img loading="lazy"
                            src={
                              item?.productimage1
                                ? item?.productimage1
                                : item?.images?.productimage1
                                  ? item?.images?.productimage1
                                  : item.image
                            }
                            alt={item.name}
                            className="w-30 h-[60px] sm:h-[80px] md:h-[120px] object-cover rounded-lg mb-2"
                          />
                          <Link
                            to={`/shop/${item?.category ? generateSlug(item?.category) : "-"
                              }/${item?.subcategory
                                ? generateSlug(item?.subcategory)
                                : "-"
                              }/${generateSlug(item?.title)}`}
                            state={{ item }}

                            className="block w-full hover:scale-105 hover:-translate-y-1"
                          >
                            <p
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                width: "98%",
                              }}
                              className={CustomeStyle.OnetextBlack}
                            >
                              {item.title}
                            </p>
                            <h3 className={CustomeStyle.description}>
                              {item.description}
                            </h3>
                            <div className="flex items-center justify-center gap-1">
                              <span className="text-black text-lg font-bold">
                                ₹{item?.salePrice}
                              </span>
                              <span className="line-through text-gray-500 text-sm">
                                ₹{item?.regularPrice}
                              </span>
                            </div>

                            {item.offer && (
                              <>
                                <p
                                  style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  className="text-sm font-semibold lining-nums"
                                >
                                  {item.label}
                                </p>
                                <div className="flex flex-row gap-2 items-center justify-center">
                                  <p className={`${CustomeStyle.text} font-bold`}>
                                    ₹{item.offerPrice}
                                  </p>
                                  <p
                                    className={`${CustomeStyle.text} line-through text-gray-400`}
                                  >
                                    ₹{item.price}
                                  </p>
                                </div>
                                <div className="absolute top-1 left-1 bg-red-400 text-white text-[10px] font-bold px-2 py-1 rounded-full shadow-md">
                                  {item.offer} Off
                                </div>
                              </>
                            )}
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            ))} */}
          {/* -------------------------------------------------- End --- Offer --------------------------------------------------------------------------------- */}
          {/* {AllData?.products && ( */}
          <div className="mt-4 sm:mt-0 w-[90%] items-center mx-auto bg-white border border-gray-300 p-3">
            <div className="flex flex-col lg:flex-row justify-between items-center h-auto mt-2 gap-4 ">
              <a
                href="https://www.fliptwirls.com/ShowSubCategory/Smart%20Phone%20&%20Tab/Apple%20Iphones/68398dbef8dd68113f2d7dee"
                className="relative w-full lg:w-[48%] aspect-[4/3]  rounded-lg overflow-hidden"
              >
                <img
                  loading="lazy"
                  src={require("../../components/assets/Banners/IPhone/3.png")}
                  alt="Image 1"
                  className="absolute inset-0 w-full h-full object-fill"
                />
              </a>

              <div className="w-full lg:w-[50%] h-auto flex flex-col gap-4  ">
                <a
                  href="https://www.fliptwirls.com/product-category/Watches/68398dbef8dd68113f2d7e4b"
                  className="relative w-full hidden items-center justify-center flex  lg:block rounded-lg overflow-hidden"
                >
                  <img
                    loading="lazy"
                    src={require("../../components/assets/Banners/Watchs/1.png")}
                    alt="Image 2"
                    className=" object-fill sm:h-[200px] lg:h-[280px] rounded-lg "
                  />
                </a>

                <div className="flex justify-between gap-2 sm:gap-4">
                  <a
                    href="https://www.fliptwirls.com/ShowSubCategory/Home%20Electronics/Air%20Conditioner/683edfd0ebb28a09a7229089"
                    className="relative block w-[50%] rounded-lg overflow-hidden"
                  >
                    <img
                      loading="lazy"
                      src={require("../../components/assets/Banners/Ac/4.png")}
                      alt="Image 3"
                      className="w-full h-[100px] object-fill sm:h-[150px] lg:h-[200px] rounded-lg shadow-md border"
                    />
                  </a>
                  <a
                    href="https://www.fliptwirls.com/ShowSubCategory/Audio%20&%20Video%20Accessories/Fire%20Stick/68398dbcf8dd68113f2d7bcd"
                    className="relative block w-[50%] rounded-lg overflow-hidden"
                  >
                    <img
                      loading="lazy"
                      src={require("../../components/assets/Banners/Remote/29.png")}
                      alt="Image 4"
                      className="w-full h-[100px]  sm:h-[150px] lg:h-[200px] object-fill rounded-lg shadow-md border"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* )} */}


          {/* {GetRecentData?.length != 0 && (
            <div className={CustomeStyle.container}>
              <div className={`${CustomeStyle.row} flex items-center gap-4 `}>
                <div className="flex justify-between items-center w-[100%] ">
                  <h3 className={CustomeStyle.headerText}>Recent View</h3>
                  {GetRecentData?.length >= 8 && (
                    <Link
                      to="/AllProductData"
                      className="text-red-500 hover:text-red-700 flex items-center space-x-2 "
                    >
                      <span className="text-black font-bold">View All</span>
                      <FiArrowRight color="#000" size={18} />
                    </Link>
                  )}
                </div>
              </div>
              <AllProduct product={GetRecentData} />
            </div>
          )} */}

          {/* {OfferData?.flags?.[2] && (
            <>
              <div
                className={
                  " flex flex-col sm:flex-row gap-4 w-[90%]  mx-auto bg-white border border-gray-300  p-3 mb-10 "
                }
              >
                <div className={"sm:w-1/2 w-full"}>
                  <h1 className={`${CustomeStyle.headerText} p-2 sm:p-1 ms-1 `}>
                    {OfferData?.flags[2]?.flag}
                  </h1>
                  <div className="grid grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4 mt-2">
                    {OfferData?.flags[2]?.products
                      .slice(0, 6)
                      .map((item, index) => {
                        return (
                          <div
                            key={index}
                            className=" rounded-lg p-4 sm:p-3 w-full text-center flex flex-col items-center justify-center border "
                          >
                            <img loading="lazy"
                              src={item?.images?.productimage1}
                              alt={item.name}
                              className="w-[90%] h-[100px] sm:h-[120px] object-contain rounded-lg "
                            />
                           

                            <Link
                              to={`/shop/${item?.category ? generateSlug(item?.category) : "-"
                                }/${item?.subcategory
                                  ? generateSlug(item?.subcategory)
                                  : "-"
                                }/${generateSlug(item?.title)}`}
                              state={{ item }}

                              className="block w-[100%] hover:scale-105 hover:-translate-y-1"
                            >
                              <p className={CustomeStyle.OneLineText}>
                                {item.title}
                              </p>

                              <div className="flex items-center flex-wrap gap-2 justify-center ">
                                <span className="text-black opacity-80 text-lg font-bold">
                                  ₹{item?.salePrice}
                                </span>
                                <span className="line-through text-gray-500 text-sm">
                                  ₹{item?.regularPrice}
                                </span>
                              </div>
                            </Link>
                          </div>
                        );
                      })}
                  </div>
                </div>

                {OfferData?.flags?.[3] && (
                  <div className={"sm:w-1/2 w-full"}>
                    <h1 className={`${CustomeStyle.headerText} p-2 sm:p-1 ms-1 `}>
                      {OfferData?.flags[3]?.flag}
                    </h1>
                    <div className="grid grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4 mt-2">
                      {OfferData?.flags[3]?.products
                        .slice(0, 6)
                        .map((item, index) => {
                          return (
                            <div
                              key={index}
                              className=" rounded-lg p-4 sm:p-3 w-full text-center flex flex-col items-center justify-center border "
                            >
                              <img loading="lazy"
                                src={item?.images?.productimage1}
                                alt={item.name}
                                className="w-[90%] h-[100px] sm:h-[120px] object-contain rounded-lg "
                              />
                              <Link
                                to={`/shop/${generateSlug(
                                  item?.category
                                )}/${generateSlug(
                                  item?.subcategory
                                )}/${generateSlug(item?.title)}`}
                                state={{ item }}

                                className="block w-[100%] hover:scale-105 hover:-translate-y-1"
                              >
                                <p className={CustomeStyle.OneLineText}>
                                  {item.title}
                                </p>

                                <div className="flex items-center flex-wrap gap-1 justify-center ">
                                  <span className="text-black opacity-80 text-lg font-bold">
                                    ₹{item?.salePrice}
                                  </span>
                                  <span className="line-through text-gray-500 text-sm">
                                    ₹{item?.regularPrice}
                                  </span>
                                </div>
                              </Link>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}
              </div>
            </>
          )} */}

          {/* {filteredProducts?.map((product) => (
            <div key={product.id} className="w-[90%] mx-auto bg-white mb-8">
              <div className="flex flex-col md:flex-row items-center bg-gradient-to-r from-red-500 to-yellow-500 text-white p-4 md:p-6 rounded-lg shadow-lg text-center md:text-left">
                <div className="w-full md:w-1/3 flex justify-center">
                  <img loading="lazy"
                    src={
                      filteredProducts[0]?.images?.productimage1
                        ? filteredProducts[0]?.images?.productimage1
                        : require("../assets/imagephone.png")
                    }
                    className="w-[100px] sm:w-[150px] md:w-[150px] lg:w-[200px] h-auto object-cover rounded-lg"
                  />
                </div>

                <div className="w-full md:w-2/3 mt-1 md:mt-0 px-4">
                  <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold">
                    🔥 Limited-Time Offer! 🔥
                  </h2>
                  <p className="mt-1 text-sm sm:text-lg lg:text-xl">
                    Get up to{" "}
                    <span className="font-bold text-2xl sm:text-3xl">50% OFF</span>{" "}
                    on selected items
                  </p>
                  <div className="mt-2 text-lg sm:text-2xl font-semibold">
                    <span>{filteredProducts[0]?.title}</span>
                  </div>
                  <button
                    onClick={() => _handleOfferData()}
                    className="mt-2 bg-white text-red-500 px-4 py-2 rounded-lg shadow-md hover:bg-gray-200 transition"
                  >
                    Grab the Deal
                  </button>
                </div>
              </div>
            </div>
          ))} */}

          {/* {OfferData?.flags &&
            OfferData?.flags?.slice(4)?.map((flagData) => (
              <div key={flagData.flag} className={CustomeStyle.container}>
                <div className="mb-2 ">
                  <div className={`${CustomeStyle.row} flex items-center gap-4`}>
                    <div className="flex justify-between items-center w-full sm:mb-2 mb-0">
                      <h3 className={CustomeStyle.headerText}>{flagData.flag}</h3>
                      {flagData?.products?.length >= 8 && (
                        <Link
                          to={`/${flagData.flag.toLowerCase()}`}
                          className="text-red-500 hover:text-red-700 flex items-center space-x-2"
                        >
                          <span className="text-black font-bold">View All</span>
                          <FiArrowRight color="#000" size={18} />
                        </Link>
                      )}
                    </div>
                  </div>

                  <div className="flex overflow-x-auto mt-2 gap-4 no-scrollbar">
                    {flagData?.products?.map((item) => (
                      <div
                        key={item._id}
                        className="bg-gray-100 rounded-lg py-2 px-1 w-[140px] sm:w-[180px] md:w-[150px] flex-none text-center
                     flex flex-col items-center justify-center relative cursor-pointer overflow-hidden"
                      >
                        <button
                          className="like-btn absolute top-2 right-2"
                          onClick={() => toggleLike(item._id)}
                        >
                          {likedProducts.has(item._id) ? (
                            <FaHeart size="24px" color="red" />
                          ) : (
                            <FaRegHeart size="24px" color="gray" />
                          )}
                        </button>
                        <img loading="lazy"
                          src={
                            item?.productimage1
                              ? item?.productimage1
                              : item?.images?.productimage1
                                ? item?.images?.productimage1
                                : item.image
                          }
                          alt={item.name}
                          className="w-30 h-[60px] sm:h-[80px] md:h-[120px] object-cover rounded-lg mb-2"
                        />
                        <Link
                          to={`/shop/${item?.category ? generateSlug(item?.category) : "-"
                            }/${item?.subcategory
                              ? generateSlug(item?.subcategory)
                              : "-"
                            }/${generateSlug(item?.title)}`}
                          state={{ item }}

                          className="block w-[100%] hover:scale-105 hover:-translate-y-1"
                        >
                          <p
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              width: "98%",
                            }}
                            className={CustomeStyle.OnetextBlack}
                          >
                            {item.title}
                          </p>
                          <h3 className={CustomeStyle.description}>
                            {item.description}
                          </h3>

                          <div className="flex items-center justify-center gap-1">
                            <span className="text-black text-lg font-bold">
                              ₹{item?.salePrice}
                            </span>
                            <span className="line-through text-gray-500 text-sm">
                              ₹{item?.regularPrice}
                            </span>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))} */}

          <div className={"w-[90%] items-center mx-auto bg-white p-1 mb-10"}>
            {/* <div className="flex justify-between items-center">
              <h1 className={CustomeStyle.headerText}>All Product</h1>
              <Link
                to="/AllProductData"
                className="text-red-500 hover:text-red-700 flex items-center space-x-2"
              >
                <span className="text-black font-bold">View All</span>
                <FiArrowRight color="#000" size={18} />
              </Link>
            </div> */}

            {/* <div className="w-[100%] sm:w-[95%] md:w-[100%]">
              <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3  sm:gap-1 lg:gap-3 mt-4 ">
                {loading ? (
                  <div className="text-center font-semibold text-lg py-5 m-5">
                    Loading...
                  </div>
                ) : productsToShow.length > 0 ? (
                  productsToShow.map((item) => (
                    <div
                      key={item._id}
                      className="bg-white shadow rounded-md overflow-hidden relative border border-gray-200 sm:px-5 sm:py-3 px-3 py-2 hover:scale-105 hover:-translate-y-1"
                    >
                      <img loading="lazy"
                        src={item?.images?.productimage1}
                        alt={item.name}
                        className="w-full h-20 sm:h-40 object-contain bg-light rounded-x"
                      />
                      <button
                        className="like-btn absolute top-2 left-2"
                        onClick={() => toggleLike(item._id)}
                      >
                        {likedProducts.has(item._id) ? (
                          <FaHeart
                            size="24px"
                            className="text-red-500 sm:text-lg text-xs"
                          />
                        ) : (
                          <FaRegHeart
                            size="24px"
                            className="text-gray-400 sm:text-lg md:text-xs"
                          />
                        )}
                      </button>
                      <button
                        onClick={() => handleAddToCart(item)}
                        className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50"
                      >
                        <FiShoppingCart className="text-black sm:text-base md:text-xl lg:text-2xl" />
                      </button>
                      <Link
                        to={`/shop/${item?.category ? generateSlug(item?.category) : "-"
                          }/${item?.subcategory ? generateSlug(item?.subcategory) : "-"
                          }/${generateSlug(item?.title)}`}
                        state={{ item }}
                        className="block"
                      >
                        <div className="mb-1 end-2 lg:mt-3 ">
                          <h2 className="sm:text-xl text-xs text-black from-neutral-600 sm:mt-0 mt-3">
                            {item.name}
                          </h2>
                          <h2
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              textAlign: "center",
                            }}
                            className={CustomeStyle.title}
                          >
                            {item.title}
                          </h2>
                          <div>
                            <span className={CustomeStyle.description}>
                              {item.description}
                            </span>
                          </div>
                          <div className="flex items-center justify-center gap-1">
                            <span className={CustomeStyle.text}>
                              ₹{item?.salePrice}
                            </span>
                            <span className={`${CustomeStyle.text} line-through`}>
                              ₹{item?.regularPrice}
                            </span>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))
                ) : (
                  <div className="text-center text-lg font-semibold">
                    No Product Found
                  </div>
                )}
              </div>
            </div> */}

            {loading ? (
              <div className="text-center my-10 text-lg font-medium">
                Loading ...
              </div>
            ) : (
              Object.entries(categoryDataMap).map(([categoryName, categoryData]) => (
                <div key={categoryName} className="my-8">
                  <h2 className="text-xl md:text-2xl font-bold mb-4">{categoryName}</h2>

                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 sm:gap-4">
                    {categoryData?.products?.slice(0, 10).map((item) => (
                      <div
                        key={item?._id}
                        className="overflow-hidden relative border border-gray-200 sm:px-5 sm:py-3 px-3 py-2 hover:scale-105 hover:-translate-y-1"
                      >
                        <img
                          src={item?.images?.productimage1}
                          alt={item.name}
                          className="w-full h-20 sm:h-40 object-contain rounded-x"
                        />

                        {/* Like Button */}
                        <button
                          className="like-btn absolute top-2 left-2"
                          onClick={() => toggleLike(item._id)}
                        >
                          {likedProducts.has(item._id) ? (
                            <FaHeart size="24px" className="text-red-500 sm:text-lg text-xs" />
                          ) : (
                            <FaRegHeart size="24px" className="text-gray-400 sm:text-lg md:text-xs" />
                          )}
                        </button>

                        {/* Cart Button */}
                        <button
                          onClick={() => handleAddToCart(item)}
                          className="like-btn absolute top-2 right-2 px-2 py-2 bg-gray-100 text-white rounded-lg hover:bg-green-50"
                        >
                          <FiShoppingCart className="text-black sm:text-base md:text-xl lg:text-2xl" />
                        </button>

                        {/* Product Link */}
                        <Link
                          to={`/shop/${item?.category ? generateSlug(item?.category) : "-"}/${item?.subcategory ? generateSlug(item?.subcategory) : "-"}/${generateSlug(item?.title)}`}
                          state={{ item }}
                          className="block"
                        >
                          <div className="mb-1 end-2 lg:mt-3">
                            <h2 className="text-black text-sm md:text-base line-clamp-1 font-bold leading-none mb-1">
                              {item.title}
                            </h2>
                            <div>
                              <span className={CustomeStyle.description}>{item.description}</span>
                            </div>
                            <div className="flex items-center justify-center gap-1">
                              <span className={CustomeStyle.text}>₹{item?.salePrice}</span>
                              <span className={`${CustomeStyle.text} line-through`}>
                                ₹{item?.regularPrice}
                              </span>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            )}

          </div>

          <button
            onClick={scrollToTop}
            className={`fixed bottom-5 right-5 border bg-gray-200 text-black font-semibold px-4 py-2 rounded-full shadow-lg transition-all duration-300 ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-0"
              }`}
          >
            ⬆ Top
          </button>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
